import { FormattedMessage } from 'react-intl'
import { NavItemType } from 'src/types'

const other: { admin: NavItemType[], space: NavItemType[], config: NavItemType[] } = {
    admin: [
        {
            id: 'dashboard',
            type: 'group',
            children: [
                {
                    id: 'dashboard',
                    title: <FormattedMessage id='dashboard' />,
                    type: 'item',
                    url: '/dashboard',
                    iconName: 'gauge',
                    breadcrumbs: false
                }
            ]
        },
        {
            id: 'space-management',
            type: 'group',
            title: <FormattedMessage id='space-management' />,
            children: [
                {
                    id: 'spaces',
                    title: <FormattedMessage id='spaces' />,
                    type: 'item',
                    url: '/space/list',
                    iconName: 'buildings',
                    breadcrumbs: false
                },
                {
                    id: 'users',
                    title: <FormattedMessage id='users' />,
                    type: 'item',
                    url: '/user/list',
                    iconName: 'users',
                    breadcrumbs: false
                }
            ]
        },
        {
            id: 'superadmin',
            title: <FormattedMessage id='superadmin' />,
            type: 'group',
            children: [
                {
                    id: 'space-list',
                    title: <FormattedMessage id='space-list' />,
                    type: 'item',
                    url: '/superadmin/spaces/list',
                    iconName: 'list',
                    breadcrumbs: false
                },
                {
                    id: 'space-template',
                    title: <FormattedMessage id='space-template' />,
                    type: 'item',
                    url: '/superadmin/space-template/list',
                    iconName: 'layout',
                    breadcrumbs: false
                },
                {
                    id: 'section-template',
                    title: <FormattedMessage id='section-template' />,
                    type: 'item',
                    url: '/superadmin/section-template/list',
                    iconName: 'squares-four',
                    breadcrumbs: false
                },
                {
                    id: 'blocks',
                    title: <FormattedMessage id='blocks' />,
                    type: 'item',
                    url: '/superadmin/blocks',
                    iconName: 'cube',
                    breadcrumbs: false
                },
                {
                    id: 'blocks-data',
                    title: <FormattedMessage id='blocks-data' />,
                    type: 'item',
                    url: '/superadmin/blocks-data/list',
                    iconName: 'database',
                    breadcrumbs: false
                },
                {
                    id: 'customer',
                    title: <FormattedMessage id='customer' />,
                    type: 'item',
                    url: '/superadmin/customer/list',
                    iconName: 'users',
                    breadcrumbs: false
                },
                {
                    id: 'plans-pricing',
                    title: <FormattedMessage id='plans-pricing' />,
                    type: 'item',
                    url: '/superadmin/plans',
                    iconName: 'tag',
                    breadcrumbs: false
                },

            ]
        },
        {
            id: 'billing',
            type: 'group',
            title: <FormattedMessage id='billing' />,
            children: [
                {
                    id: 'organization',
                    title: <FormattedMessage id='organization' />,
                    type: 'item',
                    url: '/organization',
                    iconName: 'credit-card',
                    breadcrumbs: false
                }
            ]
        },
        {
            id: 'blocks',
            title: <FormattedMessage id='block-management' />,
            type: 'group',
            children: [
                {
                    id: 'exclusive-blocks',
                    title: <FormattedMessage id='exclusive-blocks' />,
                    type: 'item',
                    url: '/exclusive-blocks',
                    iconName: 'star',
                    breadcrumbs: false
                },
            ]
        },
    ],
    space: [
        {
            id: 'overview',
            type: 'group',
            title: <FormattedMessage id='overview' />,
            children: [
                {
                    id: 'dashboard',
                    title: <FormattedMessage id='dashboard' />,
                    type: 'item',
                    url: '/dashboard',
                    iconName: 'squares-four',
                    breadcrumbs: false
                }
            ]
        },
        {
            id: 'content-creation',
            type: 'group',
            title: <FormattedMessage id='content' />,
            children: [
                {
                    id: 'pages',
                    title: <FormattedMessage id='pages' />,
                    type: 'item',
                    url: '/page/list',
                    iconName: 'file-text',
                    breadcrumbs: false
                },
                {
                    id: 'listings',
                    title: <FormattedMessage id='listings' />,
                    type: 'item',
                    url: '/listing/list',
                    iconName: 'stack',
                    breadcrumbs: false
                },
                {
                    id: 'products',
                    title: <FormattedMessage id='products' />,
                    type: 'item',
                    url: '/product/list',
                    iconName: 'user-plus',
                    breadcrumbs: false
                },
                {
                    id: 'newsletter',
                    title: <FormattedMessage id='newsletter' />,
                    type: 'item',
                    url: '/newsletter/list',
                    iconName: 'envelope-simple',
                    breadcrumbs: false
                },
                {
                    id: 'forms',
                    title: <FormattedMessage id='forms' />,
                    type: 'item',
                    url: '/form/list',
                    iconName: 'note',
                    breadcrumbs: false
                }
            ]
        },
        {
            id: 'scouting-agents',
            type: 'group',
            title: <FormattedMessage id='agents' />,
            children: [
                {
                    id: "scouting-agents",
                    title: <FormattedMessage id="scouting-agents" />,
                    type: "item",
                    iconName: 'magnifying-glass',
                    ai: true,
                    url: "/agents/scouting-agent",
                },
                {
                    id: "structuredAgent",
                    title: <FormattedMessage id="structuredAgent" />,
                    type: "item",
                    iconName: 'target',
                    ai: true,
                    url: "/structured-data-agent",
                },
                {
                    id: "contentPlanner",
                    title: <FormattedMessage id="contentPlanner" />,
                    type: "item",
                    iconName: 'sparkle',
                    ai: true,
                    url: "/content-planner",
                },
            ]
        },
        {
            id: 'space-management',
            type: 'group',
            title: <FormattedMessage id='management' />,
            children: [
                {
                    id: 'transactions',
                    title: <FormattedMessage id='transactions' />,
                    type: 'item',
                    url: '/transactions',
                    iconName: 'credit-card',
                    breadcrumbs: false
                },
                {
                    id: 'analytics',
                    title: <FormattedMessage id='analytics' />,
                    type: 'item',
                    url: '/analytics',
                    iconName: 'chart-bar',
                    breadcrumbs: false
                },
                {
                    id: 'crm',
                    title: <FormattedMessage id='crm' />,
                    type: 'item',
                    url: '/member/list',
                    iconName: 'users',
                    breadcrumbs: false
                },
                {
                    id: 'partners',
                    title: <FormattedMessage id='partners' />,
                    type: 'item',
                    url: '/partner/list',
                    iconName: 'package',
                    breadcrumbs: false
                },
                {
                    id: 'space-settings',
                    title: <FormattedMessage id='space-settings' />,
                    type: 'item',
                    url: '/config/general',
                    iconName: 'gear-six',
                    breadcrumbs: false
                }
            ]
        }
    ],
    config: [
        {
            id: 'space-settings',
            type: 'group',
            children: [
                {
                    id: 'general',
                    title: <FormattedMessage id='general' />,
                    type: 'item',
                    url: '/config/general',
                    iconName: 'folder',
                    breadcrumbs: false
                },
                {
                    id: 'styling',
                    title: <FormattedMessage id='styling' />,
                    type: 'item',
                    url: '/config/styling',
                    iconName: 'pencil-simple',
                    breadcrumbs: false
                },
                {
                    id: 'navigation',
                    title: <FormattedMessage id='navigation' />,
                    type: 'item',
                    url: '/config/navigation/list',
                    breadcrumbs: false,
                    iconName: 'compass',
                },
                {
                    id: 'communication',
                    title: <FormattedMessage id='communication' />,
                    type: 'item',
                    url: '/config/communication/list',
                    breadcrumbs: false,
                    iconName: 'chat-circle',
                },
                {
                    id: 'templates',
                    title: <FormattedMessage id='templates' />,
                    type: 'item',
                    url: '/config/template/list',
                    iconName: 'layout',
                    breadcrumbs: false
                },
                {
                    id: 'assets',
                    title: <FormattedMessage id='assets' />,
                    type: 'item',
                    url: '/config/assets',
                    iconName: 'image',
                    breadcrumbs: false
                },
                {
                    id: 'tags',
                    title: <FormattedMessage id='tags' />,
                    type: 'item',
                    url: '/config/tag/list',
                    iconName: 'tag',
                    breadcrumbs: false
                },
                {
                    id: 'seo',
                    title: <FormattedMessage id='seo' />,
                    type: 'item',
                    url: '/config/seo',
                    iconName: 'chart-bar',
                    breadcrumbs: false
                },
                {
                    id: 'newsletter',
                    title: <FormattedMessage id='newsletter' />,
                    type: 'item',
                    url: '/config/newsletter',
                    iconName: 'envelope-simple',
                    breadcrumbs: false
                },
                {
                    id: 'subscriptions',
                    title: <FormattedMessage id='subscriptions' />,
                    type: 'item',
                    url: '/config/subscription',
                    iconName: 'credit-card',
                    breadcrumbs: false
                },
                {
                    id: 'courses',
                    title: <FormattedMessage id='courses' />,
                    type: 'item',
                    url: '/config/courses',
                    iconName: 'squares-four',
                    breadcrumbs: false
                },
                {
                    id: 'integrations',
                    title: <FormattedMessage id='integrations' />,
                    type: 'item',
                    url: '/config/integrations',
                    iconName: 'lightning',
                    breadcrumbs: false
                },
                {
                    id: 'aiprompts',
                    title: <FormattedMessage id='aiprompts' />,
                    type: 'item',
                    url: '/config/aiprompt/list',
                    iconName: 'sparkle',
                    ai: true,
                    breadcrumbs: false
                },
            ]
        }
    ]
}

export default other
